import axios from "axios";
import { URL_API_BACK } from "./generals";

const getToken = () => {
  const token = localStorage.getItem("token");
  return token;
};

const axiosInstance = axios.create({
  baseURL: URL_API_BACK,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No se encontró el token");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const postData = async (url, data) => {
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;
  } catch (error) {
    console.error(`Error en la solicitud POST: ${error}`);
    throw error;
  }
};

export const getData = async (url) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error en la solicitud GET: ${error}`);
    throw error;
  }
};

export const putData = async (url, data) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error(`Error en la solicitud PUT: ${error}`);
    throw error;
  }
};

export const deleteData = async (url, data) => {
  try {
    const response = await axiosInstance.delete(url, data);
    return response.data;
  } catch (error) {
    console.error(`Error en la solicitud Delete: ${error}`);
    throw error;
  }
};
